import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

interface GetSitemapParams {
  index: string
}

export interface GetSitemapRequest extends Partial<AxiosRequestConfig> {
  params: GetSitemapParams
}

export interface GetSiteMapResponse extends AxiosResponse {
  data: string
}

export function getSitemapListApi(
  { params }: GetSitemapRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "get",
    url: `/site-map/html-sitemap-xml?pageNo=${params.index}`,
  }) as Promise<GetSiteMapResponse>
}
